module.exports = __webpack_public_path__ + "img/proj-3.947cecef.png";